import { snakeCase } from 'lodash';
import moment, { Moment } from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterContext } from 'api/automation-builder/types';
import { humanise } from 'components/atoms/humanised-date';
import { unreachable } from 'utils/unreachable';
import {
  DateFieldAbsoluteFilter,
  DateFieldFilter,
  DateFieldFilterOperationType,
  DateFieldFilterRelativeOperationTypes,
  DateFieldRelativeFilter,
  RelativeDirection,
} from '../../filters/date';

const getDate = (filter: DateFieldFilter): Moment => {
  const relative = filter as DateFieldRelativeFilter;
  const direction = relative.direction ?? RelativeDirection.Ago;
  const days = relative.days ?? 0;

  switch (direction) {
    case RelativeDirection.Ago:
      return moment().subtract(days, 'days');
    case RelativeDirection.FromNow:
      return moment().add(days, 'days');
    default:
      return unreachable(direction);
  }
};

export const format = (
  filter: DateFieldFilter,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | JSX.Element,
) => {
  const id = `task_list.filters.messages.${snakeCase(
    DateFieldFilterOperationType[filter.type],
  )}${
    DateFieldFilterRelativeOperationTypes.includes(filter?.type) &&
    filter?.field?.metaData?.filterContext === FilterContext.Automations
      ? '_minimal'
      : ''
  }`;

  return (
    getOperationOptionRenderer?.(filter.type, filter) ?? (
      <FormattedMessage
        id={id}
        values={{
          days: (filter as DateFieldRelativeFilter).days ?? 0,
          direction:
            (filter as DateFieldRelativeFilter).direction ??
            RelativeDirection.Ago,
          format: humanise(
            (filter as DateFieldAbsoluteFilter).value ?? moment(),
          ),
          date: humanise(getDate(filter)),
        }}
      />
    )
  );
};
